export const vendorDialogData = (optionData) => [
  {
    placeholder: 'Name',
    required: true,
    type: 'text',
    name: 'vendorName',
    label: 'Name ',
    star: '*',
    countrycode: false,
  },
  {
    placeholder: 'Mobile Number',
    required: true,
    type: 'text',
    name: 'number',
    label: 'Mobile Number',
    star: '*',
    countrycode: true,
  },
  {
    placeholder: 'Email ID',
    required: true,
    type: 'text',
    name: 'email',
    label: 'Email ID',
    star: '*',
    countrycode: false,
  },
  {
    placeholder: 'City',
    // required: true,
    type: 'text',
    name: 'city',
    label: 'City',
    star: '*',
    countrycode: false,
    disabled: true,
    // options:optionData
  }
];

export const subVendorDialogData = [
  {
    placeholder: 'Name',
    required: true,
    type: 'text',
    name: 'vendorName',
    label: 'Sub-Vendor Name',
    star: '*',
    countrycode: false,
  },
  {
    placeholder: 'Mobile Number',
    required: true,
    type: 'text',
    name: 'number',
    label: 'Mobile Number',
    star: '*',
    countrycode: true,
  },
  {
    placeholder: 'Email',
    required: true,
    star: '*',
    type: 'text',
    name: 'email',
    label: 'Email ID',
    countrycode: false,
  },
  {
    placeholder: 'Name',
    required: false,
    type: 'text',
    name: 'name',
    label: 'City Manager',
    star: '*',
    countrycode: false,
    disabled: true,
  },

  // {
  //   placeholder: 'Address',
  //   required: false,
  //   type: 'text',
  //   name: 'address',
  //   label: 'Address',
  //   multiline: true,
  //   row: 3,
  // },
  // {
  //   placeholder: 'City',
  //   required: false,
  //   type: 'text',
  //   name: 'city',
  //   label: 'City',
  //   countrycode: false,
  // },
  // {
  //   placeholder: 'State',
  //   required: false,
  //   type: 'text',
  //   name: 'state',
  //   label: 'State',
  //   countrycode: false,
  // },
];
export const driverDialogData = [
  {
    placeholder: 'Name',
    required: true,
    type: 'text',
    name: 'driverName',
    label: 'Driver Name',
    star: '*',
    countrycode: false,
  },
  
  {
    placeholder: 'Mobile Number',
    required: true,
    type: 'text',
    name: 'number',
    label: 'Mobile Number',
    star: '*',
    countrycode: true,
  },
  // {
  //   placeholder: 'Alternate Mobile Number',
  //   required: false,
  //   type: 'text',
  //   name: 'mobile',
  //   label: 'Alternate Mobile Number',
  //   star: '*',
  //   countrycode: true,
  // },
  // {
  //   placeholder: 'DD/MM/YYYY',
  //   required: false,
  //   type: 'date',
  //   name: 'birthday',
  //   label: 'Birthday Date',
  //   star: '*',
  //   countrycode: false,
  // },
  // {
  //   placeholder: 'Add Your Permanent Address',
  //   required: false,
  //   type: 'text',
  //   name: 'permanentaddress',
  //   label: 'Permanent Address',
  //   countrycode: false,
  // },
  // {
  //   placeholder: 'Add Your Current Address',
  //   required: false,
  //   type: 'text',
  //   name: 'currentaddress',
  //   label: 'Current Address',
  //   countrycode: false,
  // },
  // {
  //   placeholder: 'Yes or No',
  //   required: false,
  //   type: 'text',
  //   name: 'covid',
  //   label: 'Are You Covid Vaccinated?',
  //   countrycode: false,
  // },
  {
    placeholder: 'Email',
    required: false,
    type: 'text',
    name: 'email',
    label: 'Email ID',
    countrycode: false,
  },
  // {
  //   placeholder: 'Name',
  //   required: false,
  //   type: 'text',
  //   name: 'name',
  //   label: ' City Manager',
  //   star: '*',
  //   countrycode: false,
  //   disabled: true,
  // },
];
export const vehicleDialogData = (optionData,selectType) => [
  {
    placeholder: 'Image',
    required: true,
    type: 'file',
    name: 'Avtar',
    star: '*',
    countrycode: false,
    disabled:selectType === 'edit' ? true : false
  },
  {
    placeholder: 'Model Name',
    required: true,
    type: 'text',
    name: 'carModel',
    label: 'Model Name',
    star: '*',
    countrycode: false,
    disabled:selectType === 'edit' ? true : false
  },
  {
    placeholder: 'Vehicle Number',
    required: true,
    type: 'text',
    name: 'regNumber',
    label: 'Vehicle Number',
    star: '*',
    countrycode: false,
    capital:true,
    disabled:selectType === 'edit' ? true : false
  },
  {
    placeholder: 'Color',
    required: true,
    type: 'text',
    name: 'colour',
    label: 'Vehicle Color',
    star: '*',
    countrycode: false,
    disabled:selectType === 'edit' ? true : false
  },
  {
    placeholder: 'Choose fuel type',
    required: true,
    type: 'text',
    name: 'fuelType',
    label: 'Fuel Type',
    star: '*',
    countrycode: false,
    disabled:selectType === 'edit' ? true : false,
    options: selectType !== 'edit' && [
      {
        value:'Petrol', label:'Petrol'
      },
      {
        value:'Diesel', label:'Diesel'
      },
      {
        value:'CNG', label:'CNG'
      }
    ],
  },
  {
    placeholder: 'Choose category',
    required: true,
    type: 'text',
    name: selectType === 'edit' ? 'carType' : 'carTypeId',
    label: 'Category',
    star: '*',
    countrycode: false,
    options:selectType !== 'edit' && optionData,
    disabled:selectType === 'edit' ? true : false
  },
  {
    placeholder: 'seating',
    required: true,
    type: 'text',
    name: 'seating',
    label: 'Seating Capacity',
    star: '*',
    countrycode: false,
  },
  {
    required: true,
    type: 'text',
    name: 'stepney',
    label: 'Do you have Stepney ?',
    star: '*',
    values: [
      {
        value: 'true',
        label: 'Yes',
      },
      {
        value: 'false',
        label: 'No',
      },
    ],
},
  {
    required: true,
    type: 'text',
    name: 'fireExtinguisher',
    label: 'Do you have Fire Extinguisher ?',
    star: '*',
    values: [
      {
        value: 'true',
        label: 'Yes',
      },
      {
        value: 'false',
        label: 'No',
      },
    ],
},
{
  required: true,
  type: 'text',
  name: 'firstAid',
  label: 'Do you have First-aid Kit ?',
  star: '*',
  values: [
    {
      value: 'true',
      label: 'Yes',
    },
    {
      value: 'false',
      label: 'No',
    },
  ],
},
  {
    placeholder:'last Vehicle Inspection Date',
    required:false,
    type:'date',
    name:'lastInspection',
    label:'Last Vehicle Inspection Date',
    star: '*',
    disabled:selectType === 'edit' ? true : false
  },
  {
    placeholder:'last Service Date',
    required:false,
    type:'date',
    name:'lastService',
    label:'Last Service Date',
    star: '*',
    disabled:selectType === 'edit' ? true : false
  },
  {
    placeholder:'Last Meter Reading',
    required:false,
    type:'number',
    name:'lastMeterReading',
    label:'Last Meter Reading',
    star: '*',
    disabled:selectType === 'edit' ? true : false
  },
  {
    placeholder:'RC Owner',
    required:true,
    type:'text',
    name:'rcOwner',
    label:'RC Owner',
    star: '*',
    disabled:selectType === 'edit' ? true : false
  },
  {
    placeholder:'Chasis Number',
    required:true,
    type:'text',
    name:'chasisNum',
    label:'Chasis Number',
    star: '*',
    capital:true,
    disabled:selectType === 'edit' ? true : false
  },
  {
    placeholder:'Engine Number',
    required:true,
    type:'text',
    name:'engineNum',
    label:'Engine Number',
    star: '*',
    capital:true,
    disabled:selectType === 'edit' ? true : false
  },
  
];

export const subDriverDialogData = [
  {
    placeholder: 'Name',
    required: true,
    type: 'text',
    name: 'driverName',
    label: ' Driver Name',
    star: '*',
    countrycode: false,
  },
  {
    placeholder: 'Name',
    required: false,
    type: 'text',
    name: 'drivVendorName',
    label: ' City Manager',
    star: '*',
    countrycode: false,
    disabled: true,
  },
  {
    placeholder: 'Name',
    required: false,
    type: 'text',
    name: 'drivSubVendorName',
    label: ' Sub Vendor Name',
    star: '*',
    countrycode: false,
    disabled: true,
  },
  {
    placeholder: 'Mobile Number',
    required: true,
    type: 'text',
    name: 'number',
    label: 'Mobile Number',
    star: '*',
    countrycode: true,
  },
  {
    placeholder: 'Email',
    required: true,
    type: 'text',
    name: 'email',
    label: 'Email',
    star: '*',
    countrycode: false,
  },
];

export const filterdata = [
  {
    id: 1,
    primaryText: 'Status',
    subItems: [
      { value: 'Active', key: 'Status' },
      { value: 'InActive', key: 'Status' },
      { value: 'Blocked', key: 'Status' },
      { value: 'Pending', key: 'Status' }
    ]
  },
  {
    id: 2,
    primaryText: 'Location',
    subItems: [
      { value: 'Bangalore', key: 'Location' },
      { value: 'Chennai', key: 'Location' },
      { value: 'Mysore', key: 'Location' },
      { value: 'Kannur', key: 'Location' }
    ]
  }
];
export const filterStatusData = [
  {
    id: 1,
    primaryText: 'Status',
    subItems: [
      { value: 'Active', key: 'Status' },
      { value: 'InActive', key: 'Status' },
      { value: 'Blocked', key: 'Status' },
      { value: 'Pending', key: 'Status' }
    ]
  }
];

export const filterStatusVehicle = [
  {
    id: 1,
    primaryText: 'Status',
    subItems: [
      { value: 'Active', key: 'Status' },
      { value: 'InActive', key: 'Status' },
      { value: 'Rejected', key: 'Status' },
      { value: 'Pending', key: 'Status' }
    ]
  }
];

export const filterSubVendorData = [
  {
    id: 1,
    primaryText: 'Status',
    subItems: [
      { value: 'Active', key: 'Status' },
      { value: 'InActive', key: 'Status' },
      { value: 'Blocked', key: 'Status' },
      { value: 'Pending', key: 'Status' }
    ]
  }
];

export const filterSubVendorVehicleData = [
  {
    id: 1,
    primaryText: 'Status',
    subItems: [
      { value: 'Active', key: 'Status' },
      { value: 'InActive', key: 'Status' },
      { value: 'Blocked', key: 'Status' },
      { value: 'Pending', key: 'Status' },
      { value: 'Rejected', key: 'Status' }
    ]
  }
];

export const moreIconData = [
  {
    id:1,
    name:'Edit'
  },
  {
    id:2,
    name:'Block'
  },
  {
    id:3,
    name:'Deactivate'
  },
]
